import React, { DetailedHTMLProps, FC, HTMLAttributes } from 'react';

import classNames from 'classnames';

import './index.scss';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'rect' | 'circle';
  width?: number | string;
  height?: number | string;
  animation?: 'pulse' | 'wave' | false;
}

const Skeleton: FC<
  SkeletonProps &
    DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>
> = (props) => {
  const {
    animation = 'pulse',
    className,
    height,
    variant = 'text',
    width,
    ...other
  } = props;

  const hasChildren = Boolean(other.children);

  return (
    <span
      className={classNames('skeleton-root', `skeleton-${variant}`, {
        'skeleton-pulse': animation === 'pulse',
        'skeleton-wave': animation === 'wave',
        'skeleton-withChildren': hasChildren,
        'skeleton-fitContent': hasChildren && !width,
        'skeleton-heightAuto': hasChildren && !height,
        [`${className}`]: !!className,
      })}
      {...other}
      style={{
        width,
        height,
        ...other.style,
      }}
    />
  );
};

export default Skeleton;
